// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"550":"2e421c3f0285f19a","888":"2ed88d7f23d19398"}[chunkId] + ".css";
};